<template>
  <div class="text-container">
    <div class="text-content">
      <div class="mb-8 text-center w-full">FEDERAL BUREAU OF INVESTIGATION</div>

      <div>
        <span class="uppercase font-bold">Report Made at:</span>
        <TerminalHiddenWord
          text="Washington D.C."
          :encrypted="encrypted"
        />
      </div>
      <div><span class="uppercase font-bold">Report Made by:</span> Shepard Oswald</div>
      <div><span class="uppercase font-bold">Badge Number:</span> XF90D053</div>
      <div><span class="uppercase font-bold">File Number:</span> 173-99823</div>

      <div class="mt-8"><span class="uppercase font-bold">Subject:</span> THEODORE MARKSON, alias: Watson</div>
      <div class="mb-8"><span class="uppercase font-bold">Character of Case:</span> Security Matter</div>

      <div class="uppercase font-bold mb-2">Synopsis of Facts:</div>
      <div>
        <span>Subject believed to have orchestrated a series of cyber attacks targeting</span>
        <TerminalHiddenWord
          text="government surveillance and technology development facilities."
          :encrypted="encrypted"
        />
        <span>Attacks made by individual using the moniker “Watson.” Early attacks targeted</span>
        <TerminalHiddenWord
          text="the Department of Homeland Security, Department of State, and Department of Defense."
          :encrypted="encrypted"
        />
        <span>Large amounts of classified information were leaked to the public after each of these breaches. More recent attacks targeted</span>
        <TerminalHiddenWord
          text="facilities involved in artificial intelligence development, but no information has been leaked in the aftermath of these breaches."
          :encrypted="encrypted"
        />
        <span>Several days ago</span>
        <TerminalHiddenWord
          text="the North American Communications Surveillance Facility"
          :encrypted="encrypted"
        />
        <span>was targeted. It is critical that subject is apprehended before any of this data is released. Subject to be taken into custody for immediate questioning.</span>
      </div>

      <div class="uppercase font-bold mt-4 mb-2">Details:</div>
      <div class="mb-4">
        <TerminalHiddenWord
          text="Physical Description of Subject - roughly 5’9” light brown hair, brown eyes"
          :encrypted="encrypted"
        />
      </div>

      <div class="mb-4">
        <TerminalHiddenWord
          text="Confidential informant provided evidence that subject was the true identity of cyber terrorist Watson"
          :encrypted="encrypted"
        />
      </div>

      <div class="mb-4">
        <TerminalHiddenWord
          text="Successfully able to monitor subject’s online activity for past eight months"
          :encrypted="encrypted"
        />
      </div>

      <div class="mb-4">
        <TerminalHiddenWord
          text="Cyber attack incident report made by official at NACS corresponds with subject’s known online activity"
          :encrypted="encrypted"
        />
      </div>

      <div>Approved and Forwarded:</div>
      <div class="uppercase">Jennifer Vansaun</div>
      <div>Agent in Charge</div>
    </div>
  </div>
</template>

<script>
import TerminalHiddenWord from './TerminalHiddenWord'

export default {
  name: 'TerminalText',

  components: { TerminalHiddenWord },

  props: {
    encrypted: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style lang="postcss" scoped>
.text-container {
  font-family: 'input-mono';
  font-size: 14px;
  line-height: 1.71;
  @apply text-blue-lighter flex justify-center;
}

.text-content {
  word-break: break-all;
  @apply flex flex-col items-start w-4/5 border-dashed border-t-2 border-b-2 text-left py-16;
}
</style>
